<template>
  <confirmation-prompt
    id="digital-login-redirect-prompt"
    :show="show"
    :title="retrieveModalText('Title')"
    :info-text="retrieveModalText('Text')"
    :extra-wide="true"
    :confirm-button-text="retrieveModalText('ButtonText')"
    @confirm="redirectToAuthorization"
    @cancel="close"
    @close="close"
  >
  </confirmation-prompt>
</template>

<script>
import ConfirmationPrompt from '@/components/generic/presentational/molecules/confirmationPrompt/ConfirmationPrompt.vue'
import { setCookie } from '@/helpers/cookieHelper'

export default {
  components: {
    ConfirmationPrompt,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    digitalRedirectUrl: {
      type: String,
      default: null,
    },
  },
  emits: ['close'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      labelPrefix: '/QuoteActions/Forms/DigitalSigning/Authorize/',
    }
  },
  methods: {
    retrieveModalText(labelName) {
      return this.i18n.t(`${this.labelPrefix}${labelName}`) || labelName
    },
    async redirectToAuthorization() {
      setCookie('redirectUrl', location.href)
      location.href = this.digitalRedirectUrl
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped></style>
